import { Link } from '@remix-run/react';
import { useLanguageParam } from '~/config/i18n';

type BreadcrumbNavigationProps = {
  items: { title: string; href?: string }[];
};

export const BreadcrumbNavigation = ({ items }: BreadcrumbNavigationProps) => {
  const lang = useLanguageParam();

  return (
    <nav aria-label="breadcrumb">
      <ol
        className="breadcrumb"
        itemScope={true}
        itemType="https://schema.org/BreadcrumbList"
      >
        <BreadLink
          paramsValue="Fiveoffices"
          link={`/${lang}`}
          position="1"
        />
        {items.map((item, index) => (
          <BreadLink
            key={index}
            paramsValue={item.title}
            link={item.href}
            last={index === items.length - 1}
            position={(index + 2).toString()}
          />
        ))}
      </ol>
    </nav>
  );
};

const BreadLink = ({
  paramsValue,
  link,
  position,
  last = false,
}: {
  paramsValue?: string;
  link?: string;
  position: string;
  last?: boolean;
}) => {
  if (!paramsValue) {
    return null;
  }
  paramsValue = paramsValue.charAt(0).toUpperCase() + paramsValue.slice(1);

  return (
    <li
      className="breadcrumb-item caption"
      itemScope={true}
      itemProp="itemListElement"
      itemType="https://schema.org/ListItem"
    >
      {!last && link ? (
        <Link
          className={'active -regular color-grey-500'}
          itemProp="item"
          to={link}
        >
          <span itemProp="name">{paramsValue}</span>
        </Link>
      ) : (
        <span
          itemProp="name"
          className="color-primary"
        >
          {paramsValue}
        </span>
      )}
      <meta
        itemProp="position"
        content={position}
      />
    </li>
  );
};
